module.exports = __webpack_public_path__ + "static/media/sixth-mill-race-park-observation-tower.e9d662a7.mp4";